module.exports = __webpack_public_path__ + "img/ring_g_o_0_1.c8db0780.png";